module.exports = __webpack_public_path__ + "img/nicetohave-product-design-07.cdb97db9.jpg";